<template>
  <div class="rule-item">
    <div class="rule-header-wrapper">
      <div class="rule-header">
        <span class="required" v-if="isMandatory">*</span>
        <span class="label">押金退还时间</span>
        <i class="el-icon-delete delete-btn" @click="emit('remove')" v-if="!isMandatory"></i>
      </div>
      <div class="desc">还车后在指定工作日内将押金退还承租人（扣除违章、车损、违约金等费用）。</div>
    </div>
    <RuleTip :tip="tip" />
    <div class="rule-body">
      <div class="flex-row">
        <el-form-item
          :prop="`${propPrefix}.depositRefundDays`"
          :rules="getRules(60, 1)"
          class="flex-input single"
          style="margin-bottom: 0;"
        >
          <el-input
            :value="modelValue.depositRefundDays"
            @input="updateField('depositRefundDays', $event)"
            placeholder="请输入"
            size="small"
            v-integer-number
          >
            <template slot="append">个工作日</template>
          </el-input>
        </el-form-item>
      </div>
    </div>
  </div>
</template>

<script setup>
import { getRules } from './utils'
import RuleTip from './RuleTip.vue'

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
  propPrefix: {
    type: String,
    required: true,
  },
  tip: {
    type: String,
    default: '',
  },
  isMandatory: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:modelValue', 'remove'])

const updateField = (key, value) => {
  const newItem = { ...props.modelValue, [key]: value }
  emit('update:modelValue', newItem)
}
</script>

<style lang="scss" scoped>
@import './rules.scss';
</style>
